<template>
  <div>
    <facit-header></facit-header>
    <div class = "profile-div col-12">
      <h5 class="mt-3 mb-3"> Videos </h5>
      <br><br>
      <b-container class="bv-example-row">
        <h5 class="mt-3 mb-3"> People Counting </h5><br>
        <b-row>
          <b-col v-for="item in pcVideos" lg="4">
            <b-img thumbnail fluid :src="item.image" @click="info(item.link,item.name)"/>
            <br><br>
            <h6 style="text-align:center;"> {{item.name}}</h6><br><br><br>
          </b-col>
        </b-row>
      </b-container><br><br>
      <b-container class="bv-example-row">
        <h5 class="mt-3 mb-3"> Heatmap </h5><br>
        <b-row>
          <b-col v-for="item in hmVideos" lg="4">
            <b-img thumbnail fluid :src="item.image" @click="info(item.link,item.name)"/>
            <br><br>
            <h6 style="text-align:center;"> {{item.name}}</h6><br><br><br>
          </b-col>
        </b-row>
      </b-container><br><br>
      <b-container class="bv-example-row">
        <h5 class="mt-3 mb-3"> Queue Management </h5><br>
        <b-row>
          <b-col v-for="item in qmVideos" lg="4">
            <b-img thumbnail fluid :src="item.image" @click="info(item.link,item.name)"/>
            <br><br>
            <h6 style="text-align:center;"> {{item.name}}</h6><br><br><br>
          </b-col>
        </b-row>
      </b-container><br><br>
      <b-container class="bv-example-row">
        <h5 class="mt-3 mb-3"> Installation/Configuration </h5><br>
        <b-row>
          <b-col v-for="item in serverVideos" lg="4">
            <b-img thumbnail fluid :src="item.image" @click="info(item.link,item.name)"/>
            <br><br>
            <h6 style="text-align:center;"> {{item.name}}</h6><br><br><br>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal id="modalInfo" size="xl" hide-footer :title="modalInfo.title">
      <video ref="videoRef" src="" id="video-container" width="100%" controls></video>
    </b-modal>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';

export default {
  name: 'Videos',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pcVideos: [],
      hmVideos: [],
      qmVideos: [],
      serverVideos: [],
      modalInfo: { title: '', content: '' },
    };
  },
  created() {
    this.getDownloads();
  },
  methods: {
    async getDownloads() {
      const downloads = await API.get('Videos');
      downloads.forEach(records => {
        if (records.type === 0) {
          this.pcVideos.push(records)
        } else if (records.type === 1) {
          this.hmVideos.push(records)
        } else if (records.type === 2) {
          this.qmVideos.push(records)
        } else if (records.type === 3) {
          this.serverVideos.push(records)
        }
      })
    },
    info(link, title) {
        this.modalInfo.content = link
        this.modalInfo.title = title
        this.$refs.videoRef.src = link
        this.$refs.videoRef.play();
        this.$root.$emit('bv::show::modal', 'modalInfo')
      },
      resetModal() {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/videos.vue